export default "__VITE_ASSET__C9s6AVVz__"